module.exports = __webpack_public_path__ + "static/shake2-daa88f5d487257b7df8e416110bb6c8f.png";